import React, { useEffect, useRef, useState } from 'react';
import { Paperclip, Send } from 'lucide-react';
import { toast } from 'react-toastify';
import api from '../../services/api';
import SlidingPanel from '../SlidingPanel/SlidingPanel';
import styles from './CreateClientTicketPanel.module.css';

const CreateClientTicketPanel = ({ isOpen, onClose, repairRequest, onCreated }) => {
  const [message, setMessage] = useState('');
  const [files, setFiles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    setMessage('');
    setFiles([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }, [isOpen, repairRequest?.id]);

  const requestId = repairRequest?.id;
  const requestNumber = repairRequest?.request_number || repairRequest?.requestNumber || '';

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!requestId) {
      toast.error('Заявка не выбрана');
      return;
    }
    if (!message.trim() && files.length === 0) {
      toast.info('Введите сообщение или приложите файл');
      return;
    }

    const formData = new FormData();
    formData.append('repair_request', requestId);
    formData.append('content', message);
    files.forEach(file => formData.append('attachments', file));

    try {
      setIsSubmitting(true);
      const response = await api.post('/repairs/client-tickets/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      toast.success('Тикет отправлен клиенту');
      onCreated?.(response.data);
      onClose?.();
    } catch (error) {
      console.error('Ошибка создания тикета:', error);
      toast.error(error.response?.data?.error || 'Не удалось создать тикет');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key !== 'Enter' || event.shiftKey) return;
    event.preventDefault();
    handleSubmit(event);
  };

  return (
    <SlidingPanel
      isOpen={isOpen}
      onClose={onClose}
      title={requestNumber ? `Тикет по заявке ${requestNumber}` : 'Тикет по заявке'}
      width="560px"
    >
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.requestBox}>
          <span>Заявка</span>
          <strong>{requestNumber || requestId || '-'}</strong>
          {repairRequest?.customer?.name && <em>{repairRequest.customer.name}</em>}
        </div>

        <textarea
          value={message}
          onChange={(event) => setMessage(event.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Напишите вопрос клиенту по заявке"
          rows={6}
        />

        <div className={styles.actions}>
          <label className={styles.fileButton}>
            <Paperclip size={16} />
            <span>{files.length ? `Файлов: ${files.length}` : 'Прикрепить файл'}</span>
            <input
              ref={fileInputRef}
              type="file"
              multiple
              onChange={(event) => setFiles(Array.from(event.target.files || []))}
            />
          </label>

          <button type="submit" className={styles.sendButton} disabled={isSubmitting}>
            <Send size={16} />
            {isSubmitting ? 'Отправляем...' : 'Отправить'}
          </button>
        </div>
      </form>
    </SlidingPanel>
  );
};

export default CreateClientTicketPanel;
